import api from '../tools/api';

export const search = (endpoint, params = []) => api.request(
    `search-${endpoint}`,
    params
);
